export const setObjective = (objective) => ({
    type: "SET_OBJECTIVE",
    objective,
});
